<template>
    <div class="wrapper">
        <div class="operator-wraper">
            <v-row class="pl-3" v-if="isOperatorData">
                <v-col sm="12">
                    <div class="item-box">
                        <h2 class="font-weight-bold">
                            {{ $t('dueDiligence.operatorData') }}
                            <v-tooltip top color="00BD73" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </template>
                                <span>{{ $t('dueDiligence.operatorDataTT') }}</span>
                            </v-tooltip>
                        </h2>
                    </div>
                </v-col>
                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2">{{ $t('deforestation.name') }}</p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ `${report.operator.firstName || '-'} ${report.operator.lastName || ''}` }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('country') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.operator.countryId || '-' }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('dueDiligence.isoCode') }}</p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.operator?.countryIsoCode || '-' }}
                        </p>
                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('dueDiligence.eoriNumber') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.operator.eori_number || '-' }}
                        </p>
                    </div>
                </v-col>

            </v-row>
            <v-row class="pl-3" v-else>
                <v-col sm="12">
                    <div class="item-box">
                        <h2 class="font-weight-bold">
                            {{ $t('dueDiligence.operatorData') }}
                            <v-tooltip top color="00BD73" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </template>
                                <span>{{ $t('dueDiligence.operatorDataTT') }}</span>
                            </v-tooltip>
                        </h2>
                    </div>
                </v-col>
                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2">{{ $t('deforestation.name') }}</p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ `${report.user.firstName || '-'} ${report.user.lastName || ''}` }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('country') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user.countryId || '-' }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('dueDiligence.isoCode') }}</p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user?.countryIsoCode || '-' }}
                        </p>
                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('dueDiligence.eoriNumber') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user?.eori_number || '-' }}
                        </p>
                    </div>
                </v-col>

            </v-row>
        </div>

        <div class="supplier-wraper">
            <v-row class="pl-3" v-if="isSupplierData">
                <v-col sm="12">
                    <div class="item-box">
                        <h2 class="font-weight-bold">
                            {{ $t('dueDiligence.supplierData') }}
                            <v-tooltip top color="00BD73" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </template>
                                <span>{{ $t('dueDiligence.supplierDataTT') }}</span>
                            </v-tooltip>
                        </h2>
                    </div>
                </v-col>
                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.name') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ `${report.supplier.firstName || '-'} ${report.supplier.lastName || ''}` }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.email') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.supplier.email || '-' }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.phoneNumber') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.supplier.mobile || '-' }}
                        </p>
                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('country') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.supplier.countryId || '-' }}
                        </p>
                    </div>
                </v-col>

            </v-row>
            <v-row class="pl-3" v-else>
                <v-col sm="12">
                    <div class="item-box">
                        <h2 class="font-weight-bold">
                            {{ $t('dueDiligence.supplierData') }}
                            <v-tooltip top color="00BD73" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="icon-with-background" style="color:#0EBF67" v-bind="attrs" v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </template>
                                <span>{{ $t('dueDiligence.supplierDataTT') }}</span>
                            </v-tooltip>
                        </h2>
                    </div>
                </v-col>
                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.name') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ `${report.user.firstName || '-'} ${report.user.lastName || ''}` }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.email') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user.email || '-' }}
                        </p>

                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('deforestation.phoneNumber') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user.mobile || '-' }}
                        </p>
                    </div>
                </v-col>

                <v-col sm="3">
                    <div class="item-box">
                        <p class="text-subtitle-1 mb-2"> {{ $t('country') }}
                        </p>
                        <p class="text-subtitle-1 font-weight-bold">
                            {{ report.user.countryId || '-' }}
                        </p>
                    </div>
                </v-col>

            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props:{
      report:{
        type:Object,
        required: true
      }
    },
    computed:{
        isOperatorData(){
            return !Object.values(this.report.operator).every(x => x == 'N/A')
        },
        isSupplierData(){
            return !Object.values(this.report.supplier).every(x => x == 'N/A') 
        }
    }
}
</script>